export default function factory(options?: WorkerOptions | undefined): Worker {
    return new Worker(
        /* webpackChunkName: "blurhash.worker" */ new URL("./blurhash.worker.ts", import.meta.url),
        options,
    );
}
